// Idempotent body-scroll lock using a Set of token keys.
// Each modal/lock registers a unique token; class is only present
// while the set is non-empty. Removing a token that isn't registered
// is a no-op, so React 19 StrictMode double-invocation is safe.
const tokens = new Set();

export const lock = (token) => {
  tokens.add(token);
  document.body.classList.add("no-scroll");
};

export const unlock = (token) => {
  tokens.delete(token);
  if (tokens.size === 0) document.body.classList.remove("no-scroll");
};

// Back-compat wrappers used by older imports
let counterToken = 0;
export const lockBodyScroll = () => {
  const t = `auto-${++counterToken}`;
  lock(t);
  return t;
};
export const unlockBodyScroll = (t) => {
  // If called without a token, clear everything (safety fallback)
  if (t) unlock(t);
  else {
    tokens.clear();
    document.body.classList.remove("no-scroll");
  }
};
